import { API_URL } from '../../../components/config/BaseUrl';

export const GET_USER_BY_ID_URL_FOR_VERIFICATION = `${API_URL}/wificall/user`;
export const GET_USER_BY_USERNAME_URL = `${API_URL}/wificall/web/usersip`;
